module.exports = __webpack_public_path__ + "static/media/total-revenue.315c6923.svg";